import {
  useNotificationServiceNotificationItemsListKey,
  useNotificationServiceNotificationItemsUnreadCountRetrieveKey
} from '@notification/api/queries'
import { getLocalStorageTokens } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import queryString from 'query-string'
import { useEffect, useState } from 'react'

const url = import.meta.env.VITE_API_SOCKET_URL + '/ws'

const getWebSocketUrl = (token?: string | null) =>
  url && token
    ? queryString.stringifyUrl({
        url,
        query: {
          token
        }
      })
    : null

type UseNotificationsSocketProps = {
  refetchData?: boolean
  onMessage?: (data: MessageEvent) => void
}

export const useNotificationsSocket = (props?: UseNotificationsSocketProps) => {
  const queryClient = useQueryClient()
  const [hasNotifications, setHasNotifications] = useState(false)

  useEffect(() => {
    const { access } = getLocalStorageTokens()
    const socketUrl = getWebSocketUrl(access)

    if (!socketUrl) return

    const socket = new WebSocket(socketUrl)

    socket.onmessage = (data) => {
      props?.onMessage?.(data)

      setHasNotifications(true)
    }

    return () => socket.close()
  }, [])

  useEffect(() => {
    if (!(props?.refetchData && hasNotifications)) return

    queryClient.invalidateQueries({
      queryKey: [useNotificationServiceNotificationItemsListKey],
      refetchType: 'all'
    })
    queryClient.invalidateQueries({
      queryKey: [useNotificationServiceNotificationItemsUnreadCountRetrieveKey]
    })

    setHasNotifications(false)
  }, [props?.refetchData, hasNotifications, queryClient])
}
